import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import BetsButton from '../Vets/Button';
import { useStartWithdrawalMutation } from '../../redux/api/authorized/withdrawal';
import { Container, ModalContainer } from '../BaseModal';
import { selectSolanaUSDCBalance } from '../../redux/slices/walletSlice';
import { useSelector } from 'react-redux';
import BackButton from '../BackButton';

const LinkText = styled.p`
  color: ${({ theme }) => theme.primary.accent};
  font-family: Manrope;
  font-size: 12px;
  cursor: pointer;
`;

const WithdrawSelection = () => {
  const navigate = useNavigate();

  const [startWithdraw] = useStartWithdrawalMutation();

  const usdcBalance = useSelector(selectSolanaUSDCBalance);

  const handleWithdraw = async () => {
    const response = await startWithdraw({ fiatAmount: usdcBalance });
    if (response?.data) {
      window.location.href = response.data;
    }
  };

  return (
    <Container>
      <ModalContainer>
        <BackButton />
        <BetsButton
          fullWidth
          onClick={() => {
            handleWithdraw();
          }}
        >
          Withdraw USD
        </BetsButton>
        <LinkText
          style={{ textAlign: 'right' }}
          onClick={async () => {
            navigate('/app/withdraw-crypto');
          }}
        >
          Or Withdraw Crypto
        </LinkText>
      </ModalContainer>
    </Container>
  );
};

export default WithdrawSelection;
